export enum ShowWhenCondition {
  Always = 'always',
  LoggedInWithSalesTools = 'logged-in-with-sales-tools',
  Never = 'never',
}
